class OjaTrustBadges extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-badge-viewport]');
    if (!this.viewport) return;

    this.viewport.addEventListener('pointerdown', this.onPointerDown);
    this.viewport.addEventListener('pointermove', this.onPointerMove);
    this.viewport.addEventListener('pointerup', this.onPointerUp);
    this.viewport.addEventListener('pointercancel', this.onPointerUp);
    this.viewport.addEventListener('keydown', this.onKeydown);

    this.resizeObserver = new ResizeObserver(this.updateDesktopLayout);
    this.resizeObserver.observe(this.viewport);
    this.updateDesktopLayout();
  }

  disconnectedCallback() {
    this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
    this.viewport?.removeEventListener('pointermove', this.onPointerMove);
    this.viewport?.removeEventListener('pointerup', this.onPointerUp);
    this.viewport?.removeEventListener('pointercancel', this.onPointerUp);
    this.viewport?.removeEventListener('keydown', this.onKeydown);
    this.resizeObserver?.disconnect();
  }

  updateDesktopLayout = () => {
    if (!this.viewport) return;

    const item = this.viewport.querySelector('[data-badge-item]');
    if (!item) return;

    const viewportStyles = getComputedStyle(this.viewport);
    const sectionStyles = getComputedStyle(this);
    const paddingLeft = Number.parseFloat(viewportStyles.paddingLeft) || 0;
    const itemWidth = item.getBoundingClientRect().width;
    const isMobile = window.innerWidth < 750;
    const configuredGap = Number.parseFloat(
      sectionStyles.getPropertyValue(isMobile ? '--oja-badges-gap-mobile' : '--oja-badges-gap-desktop')
    ) || 0;
    const minimumGap = isMobile ? configuredGap : Math.min(configuredGap, itemWidth * 0.35);
    const availableWidth = this.viewport.clientWidth - paddingLeft;

    let fullBadges = 5;
    let gap = 0;

    while (fullBadges > 1) {
      gap = (availableWidth - itemWidth * (fullBadges + 0.5)) / fullBadges;
      if (gap >= minimumGap) break;
      fullBadges -= 1;
    }

    if (fullBadges === 1) {
      gap = Math.max(0, availableWidth - itemWidth * 1.5);
    }

    this.viewport.style.setProperty('--oja-badges-dynamic-gap', `${Math.max(0, gap)}px`);
  };

  onPointerDown = (event) => {
    if (event.pointerType === 'touch') return;
    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.startScrollLeft = this.viewport.scrollLeft;
    this.viewport.setPointerCapture(event.pointerId);
    this.viewport.setAttribute('data-dragging', '');
  };

  onPointerMove = (event) => {
    if (event.pointerId !== this.pointerId) return;
    event.preventDefault();
    this.viewport.scrollLeft = this.startScrollLeft - (event.clientX - this.startX);
  };

  onPointerUp = (event) => {
    if (event.pointerId !== this.pointerId) return;
    if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
    this.pointerId = null;
    this.viewport.removeAttribute('data-dragging');
  };

  onKeydown = (event) => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    const item = this.viewport.querySelector('[data-badge-item]');
    if (!item) return;
    event.preventDefault();
    const gap = Number.parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
    const distance = item.offsetWidth + gap;
    this.viewport.scrollBy({ left: event.key === 'ArrowRight' ? distance : -distance, behavior: 'smooth' });
  };
}

if (!customElements.get('oja-trust-badges')) {
  customElements.define('oja-trust-badges', OjaTrustBadges);
}
